import { ApplicationInsights, IConfig, IConfiguration, ITelemetryItem } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights | null = null;

const appSettings = typeof window !== "undefined" && (window as any).appSettings ? (window as any).appSettings : {};

const defaultConfig: IConfig & IConfiguration = {
    connectionString: appSettings ? appSettings["APPLICATIONINSIGHTS_CONNECTION_STRING"] : undefined,
    disableFetchTracking: true,
    disablePageUnloadEvents: ["unload"],
    disableXhr: true,
    disableAjaxTracking: true,
};

async function init(playerIdGetter?: () => string) {
    appInsights = new ApplicationInsights({
        config: defaultConfig,
    });

    const telemetryInitializer = (envelope: ITelemetryItem) => {
        envelope.tags = envelope.tags || {};
        envelope.tags["ai.cloud.role"] = "Frontend";
        envelope.tags["ai.cloud.roleInstance"] = "Frontend";
        envelope.data = envelope.data || {};
        envelope.data.playerId = playerIdGetter?.() ?? null;
        envelope.data.location = window.location.href;
        envelope.data.userAgent = window.navigator.userAgent;
        envelope.data.mobileView = environment.webView.isAppWebView;
    };

    appInsights.addTelemetryInitializer(telemetryInitializer);
    appInsights.loadAppInsights();
}

function trackEvent(name: string, properties: Record<string, any>) {
    appInsights?.trackEvent(
        {
            name: name,
        },
        {
            properties,
        }
    );
}

// Used to track exceptions with custom properties in addition to automatically tracked exceptions (other than base data).
function trackException(exception: Error, properties: Record<string, any> = {}) {
    appInsights?.trackException({ exception }, properties);
}

function trackMetric(name: string, value: number) {
    appInsights?.trackMetric({ name: name, average: value });
}

function setUserContext(id: string) {
    appInsights?.setAuthenticatedUserContext(id);
}

function clearUserContext() {
    appInsights?.clearAuthenticatedUserContext();
}

export function useAppInsights() {
    return {
        init,
        trackEvent,
        trackMetric,
        trackException,
        setUserContext,
        clearUserContext,
    };
}
